import { defineComponent } from 'vue'
import ReceiverMultiCurrency from './receiverMulticurrency';
import SenderMultiCurrency from './senderMulticurrency';
import QuickRegistration from './../quickRegistration';
import HtmlElementHelper from "../../../../../../../Shared/Helpers/htmlElementHelper";

import {
    AmountsWithTransferSummaryModel,
    MulticurrencyModel,
    MulticurrencyItemModel,
    TransferSummaryModel
} from '../../Models/AmountsWithTransferSummaryModel';

export default defineComponent({
    name: "amounts",
    template: "#amounts",
    data: function () {
        return {
            receiverAmount: 0,
            senderAmount: 0,
            displayMaxAmountWarning: false,
            displayMinAmountWarning: false,
            isSubmitButtonActive: true,
            senderAmountFocused: false,
            receiverAmountFocused: false
        }
    },
    watch: {
        transferSummaryModel: function (newVal: TransferSummaryModel, _: TransferSummaryModel) {

            this.senderAmount = newVal.AmountSent;
            this.validateSubmitButton();
        },
        receiverAmount: function (newVal: number, _: number) {

            if (this.senderAmountFocused)
                return;

            const receiverAmount = this._roundTo(Number(newVal));
            const transferFee = this._roundTo(this.transferSummaryModel.TransferFee);
            const paymentFee = this._roundTo(this.transferSummaryModel.PaymentFee);
            const exchangeRate = this._roundTo(this.transferSummaryModel.ExchangeRate, 4);

            const senderAmount = this._roundTo(receiverAmount / exchangeRate);
            const total = this._roundTo(senderAmount + transferFee + paymentFee);
            this.senderAmount = senderAmount;

            this.$emit('amountUpdated', senderAmount, total, receiverAmount);
        },
        senderAmount: function (newVal: number, _: number) {

            if (this.receiverAmountFocused)
                return;

            const senderAmount = this._roundTo(Number(newVal));
            const isValid = this.validateSenderAmount(senderAmount);
            this.isSubmitButtonActive = isValid;
            if (!isValid)
                return;

            const transferFee = this._roundTo(this.transferSummaryModel.TransferFee);
            const paymentFee = this._roundTo(this.transferSummaryModel.PaymentFee);
            const exchangeRate = this._roundTo(this.transferSummaryModel.ExchangeRate, 4);

            const receiverAmount = this._roundTo(senderAmount * exchangeRate);
            const total = this._roundTo(senderAmount + transferFee + paymentFee);
            this.receiverAmount = receiverAmount;

            this.$emit('amountUpdated', senderAmount.toFixed(2), total.toFixed(2), this.receiverAmount);
        },
        receiverMulticurrencyModel: function (newVal: MulticurrencyModel, _: MulticurrencyModel) {

            var isProductActivated = this.isReceiverProductActivated(newVal.DefaultSelectedValue.ProductSku);

            this.isSubmitButtonActive = isProductActivated;
        },
    },
    props: {
        transferSummaryModel: Object as () => TransferSummaryModel,
        senderMulticurrencyModel: Object as () => MulticurrencyModel,
        receiverMulticurrencyModel: Object as () => MulticurrencyModel,
        sku: String,
        isQuickRegistrationRequired: Boolean,
        IsRedirectToTransferPageRequired: Boolean,
        updateCurrencyUrl: String,
        isMultipleBankingProducts: String
    },
    components: {
        "ReceiverMulticurrency": ReceiverMultiCurrency,
        "SenderMulticurrency": SenderMultiCurrency,
        "QuickRegistration": QuickRegistration
    },
    methods: {
        _roundTo(num: number, digits: number = 2): number {
            const fixed = num.toFixed(digits);
            return parseFloat(fixed);
        },
        focusReceiverAmount(focused: Boolean) {
            this.receiverAmountFocused = focused;
        },
        focusSenderAmount(focused: Boolean) {
            this.senderAmountFocused = focused;
        },
        validateSenderAmount(senderAmount: number): Boolean {
            if (senderAmount < this.transferSummaryModel.MinimumAllowedTransferAmountInSenderCurrency) {
                this.displayMinAmountWarning = true;
                return false;
            }
            if (senderAmount > this.transferSummaryModel.MaxSentAmountCountryLimitInSenderCurrency) {
                this.displayMaxAmountWarning = true;
                return false;
            }
            this.displayMinAmountWarning = false;
            this.displayMaxAmountWarning = false;
            return true;
        },
        validateSubmitButton() {

            var isSenderAmountValidated = this.validateSenderAmount(this.senderAmount);
            var isReceiverProductActivated = this.isReceiverProductActivated(this.transferSummaryModel.Product.Sku);

            this.isSubmitButtonActive = isSenderAmountValidated && isReceiverProductActivated;
        },
        submitDataForm(event: SubmitEvent): Boolean {

            if (this.IsRedirectToTransferPageRequired == "True" || this.isMultipleBankingProducts == "True") {
                location.href = "transfer/" + this.transferSummaryModel.DestinationCountryName;
                event.preventDefault();
                return false;
            }
            
            if (this.isQuickRegistrationRequired) {
                this.$refs.quickRegistration.show();
                event.preventDefault();
                return false;
            }

            HtmlElementHelper.g_blockUI();
            return true;
        },
        isReceiverProductActivated(productSku: string): Boolean {
            var isActivated = this.receiverMulticurrencyModel.DeactivatedItems.
                findIndex((obj: MulticurrencyItemModel) =>
                    obj.ProductSku === productSku) == -1;

            return isActivated;
        },
        handleReceiverCurrencyUpdated(response: AmountsWithTransferSummaryModel) {
            this.$emit('receiverCurrencyUpdated', response);
        },
        handleSenderCurrencyUpdated(response: AmountsWithTransferSummaryModel) {
            this.$emit('senderCurrencyUpdated', response);
        }
    }
});